<template>
  <div
    class="loader-line w-full h-1 relative overflow-hidden bg-surface-base before:content-[''] before:absolute before:-left-1/2 before:h-1 before:w-2/5 before:bg-button-primary"
  ></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoaderLine',
})
</script>

<style scoped>
.loader-line:before {
  -webkit-animation: lineAnim 1.5s linear infinite;
  -moz-animation: lineAnim 1.5s linear infinite;
  animation: lineAnim 1.5s linear infinite;
}

@keyframes lineAnim {
  0% {
    left: -40%;
  }
  50% {
    left: 20%;
    width: 80%;
  }
  100% {
    left: 100%;
    width: 100%;
  }
}
</style>
